<template>
    <div class="loading">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped lang="scss">
    $c1: #405BFE;
    $c2: #FF0000;
    $c3: #00FF00;
    $c4: #FFFF00;
    $c5: #00FFFF;
    $c6: #FF57B3;
    $c7: #797979;
    $c8: #FF9600;
    $aux: #BBB;

    .loading {
        padding-top:20px;
        padding-left:10px;
        height: 10px;
        top:30px;
        // $colors: $c1, $c2, $c3, $c4, $c5, $c6, $c7, $c8;
        $colors: $aux, $aux, $aux, $aux, $aux, $aux, $aux, $aux;
        display: flex;
        align-items: flex-start;
        align-content: flex-end;

        .dot {
            position: relative;
            width: 14px;
            height: 14px;
            margin: 10px;
            border-radius: 50%;
            border:solid 2px #000;

            &::before {
                position: absolute;
                left:0px;
                content: "";
                width: 100%;
                height: 100%;
                background: inherit;
                border-radius: inherit;
                animation: wave 2s ease-out infinite;
            }

            @for $i from 1 through 8 {
            &:nth-child(#{$i}) {
                background: nth($colors, $i);
                &::before {
                        animation-delay: $i * 0.2s;
                    }
                }
            }
        }
    }

    @keyframes wave {
    50%,
    75% {
            transform: scale(2.5);
        }

    80%,
    100% {
            opacity: 0;
        }
    }

</style>